<div class="ig-panel">
  <section class="form-section">
    <h3 class="section-title">
      {{ "settings.integration.connectionSection" | translate }}
    </h3>

    @if (lastCalamariSync) {
      <div class="ig-status">
        <mat-icon>check_circle</mat-icon>
        <span>{{
          "settings.integration.calamari.lastSync"
            | translate: { lastCalamariSync: lastCalamariSyncFormatted }
        }}</span>
      </div>
    }

    <div class="ig-step-block">
      <p class="section-hint">
        {{ "settings.integration.calamari.configureApi" | translate }}
      </p>
      <div class="ig-toolbar">
        <button mat-stroked-button type="button" (click)="openCalamariConfig()">
          <img src="assets/img/calamari.svg" alt="" class="ig-logo" />
          {{ "settings.integration.calamari.configureButton" | translate }}
        </button>
      </div>
    </div>

    <div class="ig-step-block">
      <p class="section-hint">
        {{ "settings.integration.calamari.syncEmployeeData" | translate }}
      </p>
      <div class="ig-toolbar">
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="syncCalamari()"
          [disabled]="isCalamariSyncInProgress"
        >
          <mat-spinner
            *ngIf="isCalamariSyncInProgress"
            diameter="18"
            class="dc-btn-spinner"
          ></mat-spinner>
          <mat-icon *ngIf="!isCalamariSyncInProgress">sync</mat-icon>
          {{ "employee.sync-calamari" | translate }}
        </button>
        @if (lastCalamariSync) {
          <button
            mat-stroked-button
            type="button"
            (click)="overrideEmployeesFromCalamari()"
            [disabled]="isOverrideInProgress"
          >
            <mat-spinner
              *ngIf="isOverrideInProgress"
              diameter="18"
              class="dc-btn-spinner"
            ></mat-spinner>
            <mat-icon *ngIf="!isOverrideInProgress">refresh</mat-icon>
            {{ "employee.override-from-calamari" | translate }}
          </button>
        }
      </div>
    </div>

    @if (showCalamariProgress) {
      <app-sync-progress-bar
        [syncStateId]="calamariSyncStateId"
        [provider]="'CALAMARI'"
        (onClose)="closeCalamariProgress()"
        (onCompleted)="onCalamariSyncCompleted($event)"
      ></app-sync-progress-bar>
    }
  </section>

  <section class="form-section">
    <h3 class="section-title">
      {{ "settings.integration.advancedSettings" | translate }}
    </h3>
    <div class="field-row">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{
          "settings.integration.calamari.apiKey" | translate
        }}</mat-label>
        <input
          matInput
          [type]="hideCalamariApiKey ? 'password' : 'text'"
          [(ngModel)]="calamariConfig.apiKey"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hideCalamariApiKey = !hideCalamariApiKey"
        >
          <mat-icon>{{
            hideCalamariApiKey ? "visibility_off" : "visibility"
          }}</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{
          "settings.integration.calamari.tenant" | translate
        }}</mat-label>
        <input matInput [(ngModel)]="calamariConfig.tenant" />
        <mat-hint>{{
          "settings.integration.calamari.tenantHint" | translate
        }}</mat-hint>
      </mat-form-field>
    </div>
    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="saveCalamariConfig()"
        [disabled]="
          !calamariConfig.apiKey ||
          !calamariConfig.tenant ||
          isCalamariConfigSaving
        "
      >
        <mat-spinner
          *ngIf="isCalamariConfigSaving"
          diameter="18"
          class="dc-btn-spinner"
        ></mat-spinner>
        <mat-icon *ngIf="!isCalamariConfigSaving">save</mat-icon>
        {{
          isCalamariConfigSaving
            ? ("saving" | translate)
            : ("settings.integration.calamari.saveConfig" | translate)
        }}
      </button>
    </div>
  </section>

  <section class="form-section">
    <h3 class="section-title">
      {{ "settings.integration.calamari.absence.title" | translate }}
    </h3>
    <p class="section-hint">
      {{ "settings.integration.calamari.absence.description" | translate }}
    </p>
    <div class="option-list">
      <mat-checkbox
        color="primary"
        [checked]="calamariConfig.absenceEnabled && lastCalamariSync"
        (change)="toggleCalamariAbsence($event.checked)"
        [class.conflict-disabled]="otherAbsenceEnabled"
        [matTooltip]="
          otherAbsenceEnabled
            ? ('settings.integration.calamari.absence.conflictGoogle'
              | translate)
            : ''
        "
        [matTooltipDisabled]="!otherAbsenceEnabled"
      >
        {{ "settings.integration.calamari.absence.enabled" | translate }}
      </mat-checkbox>
    </div>
    @if (calamariConfig.absenceEnabled) {
      <div class="field-row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{
            "settings.integration.calamari.absence.label" | translate
          }}</mat-label>
          <input
            matInput
            [(ngModel)]="calamariConfig.absenceLabel"
            type="text"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{
            "settings.integration.calamari.absence.substituteText" | translate
          }}</mat-label>
          <input
            matInput
            [(ngModel)]="calamariConfig.substituteText"
            type="text"
          />
        </mat-form-field>
      </div>
      <div class="field-row">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{
            "settings.integration.calamari.absence.daysAhead" | translate
          }}</mat-label>
          <mat-select [(ngModel)]="calamariConfig.absenceDaysAhead">
            @for (
              day of [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34,
                35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
                51, 52, 53, 54, 55, 56, 57, 58, 59, 60
              ];
              track day
            ) {
              <mat-option [value]="day">
                {{ day }}
                {{ "settings.integration.calamari.absence.days" | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="saveCalamariConfig()"
        [disabled]="
          !calamariConfig.apiKey ||
          !calamariConfig.tenant ||
          isCalamariConfigSaving
        "
      >
        <mat-spinner
          *ngIf="isCalamariConfigSaving"
          diameter="18"
          class="dc-btn-spinner"
        ></mat-spinner>
        <mat-icon *ngIf="!isCalamariConfigSaving">save</mat-icon>
        {{
          isCalamariConfigSaving ? ("saving" | translate) : ("save" | translate)
        }}
      </button>
    </div>
  </section>
</div>
